import React from 'react';
import { Shield, Mail, Phone, MapPin, ExternalLink, Award, Lock, CheckCircle2 } from 'lucide-react';
import krydaIcon from '../../assets/kryda-icon.png';
import { CONTACT_PHONE, CONTACT_PHONE_HREF, CONTACT_EMAIL, CONTACT_ADDRESS } from '../../config';
import './PublicFooter.css';

const PublicFooter = () => {
  return (
    <footer className="enterprise-footer" role="contentinfo">
      {/* Compliance Strip */}
      <div className="footer-trust-strip">
        <div className="container trust-strip-inner">
          <div className="trust-badge-item">
            <Award className="trust-badge-icon" size={18} />
            <span>PCI DSS 4.0 Level 1 Ready</span>
          </div>
          <div className="trust-badge-item">
            <Lock className="trust-badge-icon" size={18} />
            <span>SOC 2 Type II Controls</span>
          </div>
          <div className="trust-badge-item">
            <Shield className="trust-badge-icon" size={18} />
            <span>HIPAA &amp; HITECH Safeguards</span>
          </div>
          <div className="trust-badge-item">
            <CheckCircle2 className="trust-badge-icon" size={18} />
            <span>GDPR Art. 32 Pseudonymization</span>
          </div>
        </div>
      </div>

      <div className="container footer-main-grid">
        {/* Company & Identity */}
        <div className="footer-brand-col">
          <div className="footer-brand-header">
            <div className="footer-logo-icon">
              <img src={krydaIcon} alt="Vaultize" className="footer-kryda-logo-img" />
            </div>
            <div>
              <span className="footer-logo-name">Vaultize</span>
              <span className="footer-parent-tag">by Kryda Cloud</span>
            </div>
          </div>
          <p className="footer-bio">
            Format-preserving encryption, PII tokenization, and privacy filtering for modern engineering teams. Built to keep sensitive customer records out of downstream databases and logs.
          </p>

          <div className="footer-contact-details">
            <div className="footer-contact-item">
              <MapPin size={15} />
              <span>{CONTACT_ADDRESS}</span>
            </div>
            <a href={CONTACT_PHONE_HREF} className="footer-contact-item">
              <Phone size={15} />
              <span>{CONTACT_PHONE}</span>
            </a>
            <a href={`mailto:${CONTACT_EMAIL}`} className="footer-contact-item">
              <Mail size={15} />
              <span>{CONTACT_EMAIL}</span>
            </a>
            <a
              href="https://krydacloud.com"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-item highlight"
            >
              <ExternalLink size={15} />
              <span>krydacloud.com</span>
            </a>
          </div>
        </div>

        {/* Column 1: Product */}
        <div className="footer-col">
          <h4 className="footer-col-title">Product</h4>
          <ul className="footer-links-list">
            <li><a href="/#simulator">Interactive Demo</a></li>
            <li><a href="/#features">Core Capabilities</a></li>
            <li><a href="/#architecture-diagrams">How It Works</a></li>
            <li><a href="/#roi-calculator">Scope Calculator</a></li>
            <li><a href="/plans">Pricing &amp; Plans</a></li>
            <li><a href="/#faq">Common Questions</a></li>
          </ul>
        </div>

        {/* Column 2: Security & Compliance */}
        <div className="footer-col">
          <h4 className="footer-col-title">Security</h4>
          <ul className="footer-links-list">
            <li><a href="/#roi-calculator">PCI DSS Descoping</a></li>
            <li><a href="/#features">HIPAA Data Protection</a></li>
            <li><a href="/#features">GDPR Pseudonymization</a></li>
            <li><a href="/#architecture-diagrams">Key Management</a></li>
            <li><a href="/#simulator">Redaction Gateway</a></li>
          </ul>
        </div>

        {/* Column 3: Resources & Account */}
        <div className="footer-col">
          <h4 className="footer-col-title">Get Started</h4>
          <ul className="footer-links-list">
            <li><a href="/signup">Create Free Account</a></li>
            <li><a href="/login">Customer Sign In</a></li>
            <li><a href="/book-demo">Schedule a Walkthrough</a></li>
            <li><a href="/docs">API Documentation</a></li>
            <li><a href={`mailto:${CONTACT_EMAIL}`}>Contact Engineering</a></li>
          </ul>
        </div>
      </div>

      <div className="container footer-bottom-row">
        <p className="copyright-text">
          &copy; {new Date().getFullYear()} Kryda Cloud Technologies Pvt. Ltd. All rights reserved.
        </p>
        <div className="footer-bottom-links">
          <a href="/#privacy">Privacy Policy</a>
          <span>&bull;</span>
          <a href="/#terms">Terms of Service</a>
          <span>&bull;</span>
          <a href={`mailto:${CONTACT_EMAIL}`}>Support</a>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
